import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})
export class OAuthService {
    private baseUrl = "https://api.notion.com/v1";
    private clientId = "a6012bf4-a538-4abc-a19b-2f6753017754";
    private redirectUri = "https://www.ketl.club/home";
    private tokenUrl = "https://api.notion.com/v1/oauth/token";
    public token;

    constructor(private http: HttpClient) {}

    loginRedirect() {
        window.location.href = `${this.baseUrl}/oauth/authorize?owner=user&client_id=${this.clientId}&redirect_uri=${encodeURIComponent(this.redirectUri)}&response_type=code`
    }

    getToken(code: string) {
        const body = new HttpParams()
            .set('grant_type', 'authorization_code')
            .set('code', code)
            .set('client_id', this.clientId);
        return this.http.post(
            `${this.tokenUrl}`,
            body.toString(),
            {
                headers: new HttpHeaders(
                    {
                        "Content-Type": "application/x-www-form-urlencoded"
                    }
                )
            }
        );
    }
}